import React from "react";
import { Grid, Page } from "tabler-react";
import PrivatePage from './PrivatePage';

function Homepage(props) {

  return (
    <PrivatePage>
      <Page.Content className="welcome-page">
        <Grid>
          <Grid.Row>
            <Grid.Col sm="12" lg="5" className="">
              <h1>
                Olá<br/><span>bem vindo!</span>
              </h1>
              <p>Aqui você tem acesso aos melhores empreendimentos de forma rápida e fácil.</p>
            </Grid.Col>
            <Grid.Col sm="12" md="7" className="">
              <img alt="welcome" src="./assets/images/welcome.png"/>
            </Grid.Col>
          </Grid.Row>
        </Grid>
        
      </Page.Content>
    </PrivatePage>
  )
}

export default Homepage;
